import { Router } from "@angular/router";
import { CountdownComponent } from "ngx-countdown";
import { TranslateService } from "@ngstack/translate";
import { ErrorStateMatcher } from "@angular/material";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";

import { SoundEnum } from "src/app/enums/sound.enum";
import { IForgottenPass } from "src/app/interfaces/forgottenPass";
import { CustomValidators } from "src/app/shared/customValidators";
import { ErrorsService } from "../../../../services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { AccountService } from "src/app/services/http/business/account/account.service";
import { timeout } from "rxjs/operators";
import { Title } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: "app-forgotten-password",
  templateUrl: "./forgotten-password.component.html",
  styleUrls: ["./forgotten-password.component.css"]
})
export class ForgottenPasswordComponent implements OnInit {
  param: any;
  errorList: IError[] = [];
  errObject: any;
  form: FormGroup;
  activateCode: number;
  nationalCode: string;
  errors = new Array();
  timer: any = 3000;
  hidePassword: boolean = true;
  hideConfirmCode: boolean = true;
  timeOut: boolean = false;
  matcher = new ErrorStateMatcher();
  codemask = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  @ViewChild("countdown") counter: CountdownComponent;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private snackBar: SnackBarService,
    public translate: TranslateService,
    private errorService: ErrorsService,
    private titleService: Title,
    private accountService: AccountService
  ) { }

  ngOnInit() {
    this.titleService.setTitle(environment.siteTitle);
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group(
      {
        NationalCode: [
          null,
          Validators.compose([
            Validators.required,
            Validators.pattern("^[0-9]*$"),
            Validators.minLength(10),
            Validators.maxLength(12)
          ])
        ],
        ActivateCode: [null, Validators.compose([Validators.required])],
        Password: [
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(4),
            Validators.maxLength(30)
            // Validators.pattern(
            //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,30}$/
            // )
          ])
        ],
        RePassword: [null, Validators.compose([Validators.required])]
      },
      { validator: CustomValidators.passwordMatchValidator }
    );
  }

  demanCode(naCode: any) {
    if (this.isEmptyOrSpaces(naCode)) {
      this.snackBar.OpenSnackBar(
        this.translate.get("require.nationalCode"),
        "ok",
        3000,
        SoundEnum.beep
      );
    } else {
      this.errors = new Array();
      this.nationalCode = naCode;
      var data = {
        NationalCode: naCode
      };
      this.accountService.resendCode(data).subscribe(
        res => {
          this.counter.restart();
          this.timer = res.returnValue * 60;
          this.hideConfirmCode = false;
          this.snackBar.OpenSnackBar(
            this.translate.get("success.confirmationCodeHasBeenSent"),
            "ok",
            5000,
            SoundEnum.beep
          );
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null;
  }

  resetTimer() {
    this.counter.restart();
  }

  onFinished() {
    if (timeout)
      this.timeOut = true;
  }

  confirmCode(element: any) {
    if (this.isEmptyOrSpaces(element)) {
      this.snackBar.OpenSnackBar(
        this.translate.get("require.confirmationCode"),
        "ok",
        3000,
        SoundEnum.beep
      );
    } else {
      this.errors = new Array();
      this.activateCode = element;
      var data = {
        ActivateCode: element.toString(),
        NationalCode: this.nationalCode
      };
      this.accountService.checkActivateUser(data).subscribe(
        () => {
          this.hidePassword = false;
        },
        err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        }
      );
    }
  }

  submit(data: IForgottenPass) {
    this.accountService.forgotPassword(data).subscribe(
      () => {
        this.router.navigate(["login"]);
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        // this.errObject = this.errorService.getError(err);
        // this.param = this.errorService.objectError(this.errObject);
        // this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
      }
    );
  }
}
